module.exports = __webpack_public_path__ + "img/register-img@2x.4e62715c.png";